
        import 'TextBox.22f110e.css-module'
        export default {"readonly":"readonly_TextBox_22f110e"}
    